import { STATISTIC_TYPE } from "types/ReportingDashboard/elements.types"
import { DEFAULT_HEADERS, DEFAULT_CHART_LABELS } from "constants/tableConversion"
import {
  RawInputData,
  TransformedTableData,
  PieChartSlice,
} from "types/tableConversion.types"
import { isStatisticType } from "../tableConversionHelpers"

/**
 * Converts DTAB (simple average) data to chart format
 */
export const convertDTABToChart = (data: RawInputData): TransformedTableData => {
  const transformedData: TransformedTableData = {
    headers: [
      { header: DEFAULT_HEADERS.CATEGORY, subHeaders: [] },
      { header: DEFAULT_HEADERS.STATISTIC, subHeaders: [] },
      { header: DEFAULT_HEADERS.VALUE, subHeaders: [] },
    ],
    rows: [],
    hasSubHeaders: false,
    barChartData: {
      keys: [DEFAULT_CHART_LABELS.AVERAGE],
      data: [],
      xAxisLabel: DEFAULT_CHART_LABELS.CATEGORIES,
      statisticTypes: [],
    },
    pieChartData: {
      categoryData: [],
      subCategoryData: [],
      statisticTypes: [],
    },
  }

  const dataRows = data.data.slice(1)
  let detectedStatType: STATISTIC_TYPE | null = null

  dataRows.forEach(row => {
    const category = row[0]
    const statisticType = row[1]
    const value = parseFloat(String(row[2])) || 0

    if (statisticType && isStatisticType(statisticType)) {
      const statType = statisticType as STATISTIC_TYPE
      if (!detectedStatType) detectedStatType = statType

      const categoryLabel = category || ""

      transformedData.rows.push([categoryLabel, statType, value])

      transformedData.barChartData.data.push({
        xValue: categoryLabel,
        [DEFAULT_CHART_LABELS.AVERAGE]: {
          [statType]: value,
        },
      })
    }
  })

  // Set statistic types
  if (detectedStatType) {
    transformedData.barChartData.statisticTypes = [detectedStatType]
    transformedData.pieChartData.statisticTypes = [detectedStatType]
  }

  // Sort bar chart data by category name
  transformedData.barChartData.data.sort((a, b) => {
    return String(a.xValue).localeCompare(String(b.xValue))
  })

  // Create pie chart data
  if (detectedStatType) {
    const pieSlices: PieChartSlice[] = transformedData.barChartData.data.map(
      item => ({
        id: item.xValue,
        label: item.xValue,
        value: (item[DEFAULT_CHART_LABELS.AVERAGE] as { [key: string]: number })[detectedStatType!],
      })
    )

    transformedData.pieChartData.categoryData = [
      {
        statistic: detectedStatType,
        data: pieSlices,
      },
    ]
  }

  return transformedData
}